import { b as j } from "./withEditable-7d0a220a.js";
import { jsx as n, jsxs as D } from "react/jsx-runtime";
import { Container as _ } from "@adobe/aem-react-editable-components";
import { AuthoringUtils as G } from "@adobe/aem-spa-page-model-manager";
import { ThemeProvider as L } from "@ucl/shared-component-foundations";
import { c as z } from "./index-0371017d.js";
import { useMemo as P, useRef as M } from "react";
import Y, { useTheme as H } from "styled-components";
import { useEditableParentStyle as X } from "./hooks.js";
import { u as B } from "./useViewPortProps-0c0b5cc6.js";
var m = /* @__PURE__ */ function(e) {
  return e.HORIZONTAL = "row", e.VERTICAL = "column", e.VERTICAL_REVERSE = "column-reverse", e.HORIZONTAL_REVERSE = "row-reverse", e;
}({}), i = /* @__PURE__ */ function(e) {
  return e.NONE = "none", e.LEFT = "start", e.CENTER = "center", e.RIGHT = "end", e.LEFT_RIGHT = "space-between", e;
}({});
const V = /* @__PURE__ */ Y.div.withConfig({
  displayName: "FlexContainer__StyledFlexContainer",
  componentId: "sc-ef4f73cc-0"
})(({ $styles: e = {}, ...o }) => ({
  "&.FlexContainer": {
    position: "relative",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    color: o.theme.colors.page.color,
    containerType: "inline-size",
    ...e,
    "> .cq-Editable-dom": {
      width: "100%",
      flex: 1,
      boxSizing: "border-box",
      containerType: "inline-size"
    }
  }
}));
function W(e) {
  const { layout: o = m.HORIZONTAL, horizontalAlign: a = i.NONE, verticalAlign: s = i.NONE, gap: p, margin: E, padding: x, width: f = "100%", maxWidth: N = "100%", backgroundColor: b = "transparent", mode: u = "inherit", flex: l = 1, zIndex: h, borderRadius: C, boxShadow: R, shouldWrap: c, borderRequired: Z, shouldHide: k, className: T, style: O = {}, columnClassNames: q = {}, ...g } = B(e), U = P(() => G.isInEditor(), []), w = M(null), { components: { flexContainer: { Container: r } } } = /* @__PURE__ */ H(), y = Z ? r == null ? void 0 : r.border : "0", I = (r == null ? void 0 : r.backgroundColor[b]) || b, v = P(() => {
    const t = a === i.NONE ? void 0 : a, S = s === i.NONE ? void 0 : s;
    return {
      flexDirection: o,
      justifyContent: o === m.HORIZONTAL ? t : S,
      alignItems: o === m.HORIZONTAL ? S : t
    };
  }, [
    a,
    o,
    s
  ]);
  X(w, {
    display: "flex",
    flexWrap: c ? "wrap" : "nowrap",
    flex: l,
    position: "relative",
    boxSizing: "border-box",
    margin: E,
    width: f,
    maxWidth: N,
    zIndex: h,
    border: y,
    borderRadius: C,
    boxShadow: R,
    backgroundColor: I
  });
  const d = /* @__PURE__ */ H(), F = {
    ...d,
    themeName: d.themeName,
    mode: u === "inherit" ? d.mode : u,
    productTeamName: "AEM Provider"
  }, A = (t) => q[t] ?? "";
  return U ? /* @__PURE__ */ n(L, {
    ...F,
    children: /* @__PURE__ */ D("div", {
      ref: w,
      style: {
        width: "100%",
        boxSizing: "border-box"
      },
      children: [
        /* @__PURE__ */ n(V, {
          as: _,
          getItemClassNames: A,
          $styles: {
            display: "flex",
            flexWrap: c ? "wrap" : "nowrap",
            flex: l,
            gap: p,
            padding: x,
            width: "100%",
            ...O,
            ...v
          },
          className: z([
            "FlexContainer",
            T
          ]),
          ...g
        }),
        /* @__PURE__ */ n("div", {
          "data-cq-data-path": `${e.cqPath}/*`,
          className: "new section"
          // class name is an aem recognizer
        })
      ]
    })
  }) : /* @__PURE__ */ n(L, {
    ...F,
    children: /* @__PURE__ */ n(V, {
      as: _,
      getItemClassNames: A,
      $styles: {
        display: k ? "none" : "flex",
        flexWrap: c ? "wrap" : "nowrap",
        flex: l,
        width: f,
        maxWidth: N,
        gap: p,
        margin: E,
        padding: x,
        zIndex: h,
        boxShadow: R,
        borderRadius: C,
        border: y,
        backgroundColor: I,
        ...O,
        ...v
      },
      className: z([
        "FlexContainer",
        T
      ]),
      ...g
    })
  });
}
W.displayName = "FlexContainer";
const J = "ucl/components/flexcontainer", le = "ucl/components/container", K = {
  emptyLabel: "Flex Container",
  isEmpty: () => !1,
  resourceType: J,
  disableResizable: !0
}, ce = j(K, W);
export {
  i as A,
  le as D,
  ce as E,
  J as F,
  m as L
};
